import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosGet } from "utils/APIHelper";
import { PAGE_SIZE } from "utils/CommonConstants";
import { responseTypes } from "utils/Types";

const initialState: any = {
  status: "idle",
  userDashboardLoader: false,
  innCodeDetails: [],
  externalUserDetails: {},
  properties: {
    records: [],
    count: 0
  },
  propertyDetails: {
    name: "",
    filters: [],
    users: {
      count: 0,
      records: []
    }
  },
  filters: {
    roles: [],
    includeAboveProperty: false
  }
};

export const fetchPropertyDetails = createAsyncThunk("fetchPropertyDetails", async (data: any, thunkApi?: any) => {
  const API_URL = `associates?page=${data?.page || 0}&size=${PAGE_SIZE}&innCodes=${data.innCodes || ""}&roles=${
    data?.roles || ""
  }&searchText=${data?.searchText || ""}&userType=${data?.userType || ""}&includecorpusers=${
    data?.includecorpusers ?? true
  }`;
  const response = await axiosGet(API_URL, "user");

  if (response?.status === responseTypes.success) {
    return response.data;
  } else {
    return thunkApi.rejectWithValue(response.response.data);
  }
});

export const fetchExternalUserDetails = createAsyncThunk(
  "fetchExternalUserDetails",
  async (data?: any, thunkApi?: any) => {
    const API_URL = `associates?page=0&size=${PAGE_SIZE}&hltIds=${data?.hltIds}`;
    const response = await axiosGet(API_URL, "user");

    if (response?.status === responseTypes.success) {
      response.data.innCodes = response.data?.users[0]?.innCodes.map((i: any) => ({ innCode: i }));

      return response.data;
    } else {
      return thunkApi.rejectWithValue(response.response.data);
    }
  }
);

export const UserDashboardSlice = createSlice({
  name: "userDashboard",
  initialState,
  reducers: {
    setProperties: (state, action) => {
      state.properties = action.payload;

      if (!action?.payload?.records?.length) {
        state.propertyDetails = {
          name: "",
          filters: [],
          users: {
            count: 0,
            records: []
          }
        };
      }
    },

    setUserDashboardFilters: (state, action) => {
      state.filters = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExternalUserDetails.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchExternalUserDetails.fulfilled, (state, action) => {
        state.status = "idle";
        state.externalUserDetails = action.payload?.users[0];
        state.innCodeDetails = action.payload?.innCodes;
      })
      .addCase(fetchExternalUserDetails.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(fetchPropertyDetails.pending, (state, action) => {
        state.status = "loading";
        state.userDashboardLoader = true;
      })
      .addCase(fetchPropertyDetails.rejected, (state, action) => {
        state.status = "failed";
        state.propertyDetails = {
          ...state.propertyDetails,
          filters: [],
          users: {
            count: 0,
            records: []
          }
        };
        state.userDashboardLoader = false;
      })
      .addCase(fetchPropertyDetails.fulfilled, (state, action) => {
        const index = state.properties.records.findIndex((p: any) => p?.innCode === action?.meta?.arg?.innCodes);

        state.status = "idle";
        state.propertyDetails.name = state.properties.records[index]?.name;
        state.propertyDetails.users.records =
          !action.meta.arg?.page || action.meta.arg?.page === 0
            ? action.payload?.users || []
            : [...state.propertyDetails.users.records, ...action.payload.users];
        state.propertyDetails.filters = action.payload?.meta?.filters || [];
        state.propertyDetails.users.count = action.payload?.meta?.page?.total || 0;
        state.userDashboardLoader = false;
      });
  }
});

export const { setProperties, setUserDashboardFilters } = UserDashboardSlice.actions;

export default UserDashboardSlice.reducer;
